const modalForm = {
	el: {
		body: document.body,
		buttonOpenModal: document.querySelectorAll('.js-open-modal'),
		buttonCloseModal: document.querySelector('.js-close-modal'),
		modal: document.querySelector('.js-modal')
	},

	fxOpenModal() {
		this.el.body.classList.add('no-scroll-hidden')
		this.el.modal.style.display = 'flex'
	},

	fxCloseModal() {
		this.el.body.classList.remove('no-scroll-hidden')
		this.el.modal.removeAttribute('style')
	},

	events() {
		for (const button of this.el.buttonOpenModal)
			button.addEventListener('click', () => this.fxOpenModal())

		this.el.buttonCloseModal.addEventListener('click', () => this.fxCloseModal())

	},

	init() {
		this.el.modal && this.events()
	}
}
modalForm.init()